import React, { useState, useRef, useContext, useImperativeHandle, useEffect } from 'react';
import moment, { Moment } from 'moment';

import styles from './index.module.scss';
import { createWeekDate, getTimeRange } from 'component/CalendarBar/utils';
import { Button, Popover } from 'antd';
import Calendar, { CalendarRefProps } from 'component/Calendar';
import Icon from 'component/Icon';
import { ChooseType, CurrentMode } from 'page/MeetingSchedule/types/type';
import { useScheduleContext } from 'page/MeetingSchedule/Provider/ScheduleProvider';
import { useDispatch, useSelector } from 'react-redux';
import { getCalendarMeetings, setMeetingOrderParams } from 'model/meeting';
import eventBus from '../../utils/event';
import { LeftOutlined, RightOutlined } from '@ant-design/icons';
import { RootState } from 'model';
import { useMeetingTaskDate } from 'util/meeting';
import { useHistory } from 'react-router-dom';
import { queryStringify } from 'util/format';
import { getLatestTime } from 'page/MeetingSchedule/utils/timeUtils';
import { appMessageError } from 'model/app';

const today = moment(moment().format('YYYY-MM-DD'));

interface IProps {
  binkTime?: Moment | undefined;
}

const TopBar: React.FC<IProps> = ({ binkTime }) => {
  const { scheduleDispatch, originState } = useScheduleContext();
  const { currentMode, currentTime, calendarMonth, isFirstBlink } = originState;
  const dispatch = useDispatch();
  const history = useHistory();

  const calendarRef = useRef<CalendarRefProps>(null);
  const [current, setCurrentDate] = useState<Moment>(moment(currentTime));
  const [selectDate, setSelectDate] = useState(current);

  const calendarMeetingRecords = useSelector((state: RootState) => state.meeting.calendarMeetingRecords);
  const { taskList } = useMeetingTaskDate(calendarMeetingRecords);

  useEffect(() => {
    console.log(calendarMeetingRecords, 'calendarMeetingRecords');
  }, [calendarMeetingRecords]);

  const onSelectDate = (date: number) => {
    scheduleDispatch({
      type: 'SET_STATE',
      payload: {
        currentTime: date
      }
    });
  };

  const onSwitch = (beginTime: number, endTime: number) => {
    dispatch(
      getCalendarMeetings({
        beginTime,
        endTime,
        markConflict: true
      })
    );
  };

  const onVisibleChange = (visible: boolean) => {
    const ref = calendarRef.current;
    if (visible && ref) {
      ref.setDate(current.valueOf());
      ref.setSelectDate(selectDate.valueOf());
    }
  };

  // 回到今天逻辑
  const handleToday = () => {
    setCurrentDate(today);
    setSelectDate(today);
    eventBus.emit('onDataChange', today);
    eventBus.emit('onSelectChange', today);
    onSelectDate(today.valueOf());
    const dateList = createWeekDate(today);
    onSwitch && onSwitch(...getTimeRange(dateList[0], dateList[dateList.length - 1]));
    scheduleDispatch({
      type: 'SET_STATE',
      payload: {
        calendarMonth: today
      }
    });
  };

  // 切换模式
  const handleSwitshMode = (currentMode: CurrentMode) => {
    scheduleDispatch({
      type: 'SET_STATE',
      payload: {
        currentMode
      }
    });
  };

  const scheduleClass = `${styles.mode_switch_item} ${currentMode === CurrentMode.schedule && styles.mode_active}`;
  const calendarClass = `${styles.mode_switch_item} ${currentMode === CurrentMode.calendar && styles.mode_active}`;

  const setDateTopBar = (date: Moment) => {
    const ref = calendarRef.current;
    ref && ref.setDate(date.valueOf());
    setCurrentDate(date);
  };

  const setSelectDateTopBar = (selectDate: Moment) => {
    const ref = calendarRef.current;
    setSelectDate(selectDate);
    ref && ref.setSelectDate(selectDate.valueOf());
  };

  const handleMeeting = () => {
    const query: any = { from: 'schedule' };
    query.currentMode = currentMode;
    const now = moment(moment());
    const targetTime = currentMode === CurrentMode.calendar ? now : moment(currentTime);
    if (moment(currentTime).isSame(now, 'day')) {
      history.push(`/order-meeting${queryStringify(query) || ''}`);
      return;
    }
    const startTime = getLatestTime(targetTime);
    if (startTime.isBefore(now, 'day')) {
      history.push(`/order-meeting${queryStringify(query) || ''}`);
      return;
    }
    query.startTime = startTime.valueOf();
    query.endTime = startTime.add(30, 'minutes').valueOf();
    dispatch(setMeetingOrderParams({ startTime: startTime.valueOf(), endTime: startTime.add(30, 'minutes').valueOf() }));
    history.push(`/order-meeting${queryStringify(query) || ''}`);
  };

  useEffect(() => {
    eventBus.on('onDataChange', setDateTopBar);
    eventBus.on('onSelectChange', setSelectDateTopBar);
    return () => {
      eventBus.off('onDataChange', setDateTopBar);
      eventBus.off('onSelectChange', setSelectDateTopBar);
    };
  }, []);

  useEffect(() => {
    setCurrentDate(moment(currentTime));
    setSelectDate(moment(currentTime));
    if (currentMode === CurrentMode.calendar) {
      const targetCalendarMonth = !!binkTime && isFirstBlink ? binkTime : moment(currentTime);
      scheduleDispatch({
        type: 'SET_STATE',
        payload: {
          calendarMonth: targetCalendarMonth
        }
      });
    }
  }, [currentTime, currentMode]);

  const handleSetMonth = (type: ChooseType) => {
    scheduleDispatch({
      type: 'SET_STATE',
      payload: {
        calendarMonth: calendarMonth.add(type, 'month')
      }
    });
  };

  const getCalendar = () => <Calendar ref={calendarRef} onSelectDate={onSelectDate} noticeList={[]} taskList={taskList} />;

  return (
    <div className={styles.wrap}>
      <div className={styles.wrap_left}>
        {currentMode === CurrentMode.schedule && (
          <Popover content={getCalendar()} onVisibleChange={onVisibleChange} placement="topLeft" title="" overlayClassName={styles.popover} trigger="hover">
            <span className={styles.textWrap}>
              <span className={styles.text}>{current.format('YYYY年MM月')}</span>
              <Icon size={16} type="iconinput_arrow_down_ic1x" />
            </span>
          </Popover>
        )}
        {currentMode === CurrentMode.calendar && (
          <div className={styles.calendar_content}>
            {/* 顶层维护一个时间，每次切到日历时将当前的current给到origin */}
            <div className={styles.text}>{calendarMonth.format('YYYY年MM月')}</div>
            <div className={styles.left_right}>
              <LeftOutlined onClick={() => handleSetMonth(ChooseType.back)} className={styles.icon} />
              <RightOutlined onClick={() => handleSetMonth(ChooseType.go)} className={styles.icon} />
            </div>
          </div>
        )}

        <div className={styles.wrap_right}>
          <span className={styles.button} onClick={handleToday}>
            今天
          </span>
          <div className={styles.mode_switch}>
            <div className={scheduleClass} onClick={() => handleSwitshMode(CurrentMode.schedule)}>
              日程
            </div>
            <div className={calendarClass} onClick={() => handleSwitshMode(CurrentMode.calendar)}>
              日历
            </div>
          </div>
        </div>
      </div>

      <Button onClick={handleMeeting} type="primary" className={styles.booking_meeting}>
        预约会议
      </Button>
    </div>
  );
};

export default TopBar;
